export enum InventoryAction {
  ADD_STOCK = "ADD_STOCK",
  REMOVE_STOCK = "REMOVE_STOCK",
  DRAWDOWN_STOCK = "DRAWDOWN_STOCK",
  ARCHIVE_ITEM = "ARCHIVE_ITEM",
}

export enum ItemSortType {
  CATEGORY = "CATEGORY",
  USAGE = "USAGE",
  DEFINED_ORDER = "DEFINED_ORDER",
  NAME = "NAME",
  PRICE = "PRICE",
}
